module.exports = __webpack_public_path__ + "img/건강한 고령자(AIP)_old.d0c3fc16.png";